module.exports = __webpack_public_path__ + "static/media/App_store.c0b30ce6.png";